

export function appUrl(app) {
    if (!app){
        return "";
    }
    return `/#/app/${app.id}/devices/`;
}